import router from '../../routes'
import axios from 'axios'
let timeoutVar = null

export function login ({commit,getters, dispatch},payload) {
    axios.post('/auth/login',{
             email: payload.email,
             password: payload.password
         })
         .then(res => {
            //  console.log(res);
             if(res && res.status==200 && res.data && res.data.success){
              //  console.log('login',res);
             
               commit('setLogin',res.data);

               localStorage.setItem('token',res.data.token);
               localStorage.setItem('user',res.data.user);
               localStorage.setItem('enums',JSON.stringify(res.data.enums));
               localStorage.setItem('enumsLinhaVazia',JSON.stringify(res.data.enumsLinhaVazia));
               localStorage.setItem('enumsObjs',JSON.stringify(res.data.enumsObjs));
               localStorage.setItem('menu',JSON.stringify(res.data.menuWeb));
               localStorage.setItem('empresaDest',JSON.stringify(res.data.empresaDest));
               
               router.push('/');

               const tempoMili = getters.dataRenovar.getTime() - new Date().getTime()
              //  console.log('TEMPOMILI', tempoMili) // sete dias em milisegundos
              //  console.log('TEMPOMILI', typeof tempoMili)
               timeoutVar = setTimeout(function (commit, getters, thiss) {
                 atualizarTokenLogin(commit, getters, dispatch, thiss)
               }, tempoMili, commit, getters, this)
             }else{
              commit('setErrorLogin',true);
             }
         }, () => {
          commit('setErrorLogin',true);
          //  if (error.response.status === 401) {
          //    commit('setErrorLogin',true);
          //  }else{
          //    erro_geral(error);                
          //  }
          //  return error;
         })       
}

export function setLogoutTimer(){//({commit,dispatch},payload){
   // setTimeout(()=>{
   //   dispatch('logout');
   // },payload * 1000 );
 }

/*export function tryAutoLogin ({commit}) {
    const token = localStorage.getItem('token');
    //console.log("TOKEN AUTO",token);
    if(!token){
      return;
    }
   
   // const expirationDate = localStorage.getItem('expirationDate');
   // const now = new Date();
   // if(now >= expirationDate ){
   //   return;
   // }
   // console.log(expirationDate);
    const user = localStorage.getItem('user');
    commit('setLogin',{
      token: token,
      user: user
    });
}*/

export function logout({commit}){
    commit('clearLogin');
   
   // localStorage.removeItem('expirationDate');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('enums');
    localStorage.removeItem('menu');    
    localStorage.removeItem('enumsLinhaVazia');
    localStorage.removeItem('enumsObjs');
    localStorage.removeItem('empresaDest');
    
   //
    router.replace('/login');
    clearTimeout(timeoutVar)
}

export function storeUser(){//({commit,state},userData){
   // if(!state.idToken){
   //   return;
   // }
   //
   // axios.post('users.json'+'?auth='+state.idToken,userData)
   //   .then(res => console.log(res))
   //   .catch( error=> console.log(error))        ;
 }

 export function fetchUser(){//({commit,state}){
 //
 //   if(!state.idToken){
 //     return;
 //   }
 //
 //   axios.get('/users.json'+'?auth='+state.idToken)
 //     .then( response => {
 //       console.log(response);
 //       const data = response.data;
 //       const users = [];
 //       for(let key in data){
 //         const user = data[key];
 //         user.id = key;
 //         users.push(user);
 //       }
 //
 //       console.log(users);
 //     //  this.email = users[0].email;
 //     commit('storeUser',users[0]);
 //
 //     })
 //     .catch( error => console.log(error));
 //
}



export function tryAutoLogin ({ commit, getters, dispatch }) {
  const token = localStorage.getItem('token')
  // console.log('t-'+token+'-');
  if (!token || token === null || token === '' || typeof token == 'undefined' || token == 'undefined') {
    return
  }else{
    // console.log('t2-'+(typeof token)+'-');
  }
  const user = localStorage.getItem('user')
  
  let enums = localStorage.getItem('enums');
  if (enums && enums !== null && enums !== '') {
    enums = JSON.parse(enums);
  }

  let enumsLinhaVazia = localStorage.getItem('enumsLinhaVazia');
  if (enumsLinhaVazia && enumsLinhaVazia !== null && enumsLinhaVazia !== '') {
    enumsLinhaVazia = JSON.parse(enumsLinhaVazia);
  }

  let enumsObjs = localStorage.getItem('enumsObjs');
  if (enumsObjs && enumsObjs !== null && enumsObjs !== '') {
    enumsObjs = JSON.parse(enumsObjs);
  }

  let empresaDest = localStorage.getItem('empresaDest');
  if (empresaDest && empresaDest !== null && empresaDest !== '') {
    empresaDest = JSON.parse(empresaDest);
  }
  
  
  let menu = localStorage.getItem('menu');
  if (menu && menu !== null && menu !== '') {
    menu = JSON.parse(menu);
  }
  
  

  // console.log('menu', enums)
  // const menu = LocalStorage.getItem('menu')
  
  commit('setLogin', {
    token: token,
    user: user,
    enums: enums,
    enumsLinhaVazia: enumsLinhaVazia,
    enumsObjs: enumsObjs,
    menuWeb: menu,
    empresaDest: empresaDest
    // menu: menu
  })

  // console.log("1", this._vm.$toastr)
  atualizarTokenLogin(commit, getters, dispatch, this)
}

function atualizarTokenLogin (commit, getters, dispatch, thiss) {

  //verificando se o token foi alterado em outra tela
  const tokenStorage = localStorage.getItem('token');
  const tokenStore = getters.getToken
  if(tokenStorage!=null && tokenStore!=null && tokenStorage!=tokenStore){
    commit('setToken', tokenStorage);
  }
  //fim - verificando se o token foi alterado em outra tela

  axios.post('/auth/refresh')
    .then(res => {
      if (res && res.status === 200 && res.data && res.data.user) {
        commit('setLogin', res.data)
        localStorage.setItem('token', res.data.token)
        localStorage.setItem('user', res.data.user)
        localStorage.setItem('enums',JSON.stringify(res.data.enums));
        localStorage.setItem('enumsLinhaVazia',JSON.stringify(res.data.enumsLinhaVazia));
        localStorage.setItem('enumsObjs',JSON.stringify(res.data.enumsObjs));
        localStorage.setItem('menu', JSON.stringify(res.data.menuWeb));
        localStorage.setItem('empresaDest', JSON.stringify(res.data.empresaDest));
        

        const tempoMili = getters.dataRenovar.getTime() - new Date().getTime()
        
        timeoutVar = setTimeout(function (commit, getters, thiss) {
          atualizarTokenLogin(commit, getters, dispatch, thiss)
        }, tempoMili, commit, getters, thiss)
      }
    }, error => {
      if (error.response && error.response.status === 401) {
       
          
        // console.log("2", thiss._vm.$toastr)
        thiss._vm.$toastr('error',"A Sua sessão no servidor expirou. Por favor faça Login novamente.")

          
          dispatch('logout')
       
      } else {
        // console.log('ERRO CON', error)

        // erro de conexão com servidor, tenta novamente em uma hora
        timeoutVar = setTimeout(function (commit, getters, thiss) {
          atualizarTokenLogin(commit, getters, dispatch, thiss)
        }, 3600000, commit, getters, thiss)
      }
      return error
    })
}